import React, { Component } from "react";

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        { realm: "1st cultivation realm", level1: "8,000.00", level2: "72,000.00", level3: "584,000.00", level4: "4,680,000.00", level5: "37,448,000.00" },
        { realm: "2nd cultivation realm", level1: "20,000.00", level2: "180,000.00", level3: "1,460,000.00", level4: "11,700,000.00", level5: "93,620,000.00" },
        { realm: "3rd cultivation realm", level1: "40,000.00", level2: "360,000.00", level3: "2,920,000.00", level4: "23,400,000.00", level5: "187,240,000.00" },
        { realm: "4th cultivation realm", level1: "80,000.00", level2: "720,000.00", level3: "5,840,000.00", level4: "46,800,000.00", level5: "374,480,000.00" },
        { realm: "5th cultivation realm", level1: "120,000.00", level2: "1,080,000.00", level3: "8,760,000.00", level4: "70,200,000.00", level5: "561,720,000.00" },
        { realm: "6th cultivation realm", level1: "160,000.00", level2: "1,440,000.00", level3: "11,680,000.00", level4: "93,600,000.00", level5: "748,960,000.00" },
        { realm: "7th cultivation realm", level1: "200,000.00", level2: "1,800,000.00", level3: "14,600,000.00", level4: "119,000,000.00", level5: "938,200,000.00" },
        { realm: "8th cultivation realm", level1: "240,000.00", level2: "2,160,000.00", level3: "17,520,000.00", level4: "140,400,000.00", level5: "1,123,440,000.00" },
        { realm: "9th cultivation realm", level1: "280,000.00", level2: "2,520,000.00", level3: "20,400,000.00", level4: "163,800,000.00", level5: "1,310,680,000.00" },
        { realm: "10th cultivation realm", level1: "320,000.00", level2: "2,880,000.00", level3: "23,360,000.00", level4: "187,200,000.00", level5: "1,497,470,000.00" },
        { realm: "11th cultivation realm", level1: "360,000.00", level2: "3,240,000.00", level3: "26,505,800.00", level4: "210,825,800.00", level5: "1,685,385,800.00" },
        { realm: "12th cultivation realm", level1: "400,000.00", level2: "3,600,000.00", level3: "29,200,000.00", level4: "234,000,000.00", level5: "1,872,400,000.00" },
      ],
    };
  }

  render() {
    return (
      <div className="overflow-x-auto p-4">
        <div className="shadow-lg rounded-lg overflow-hidden">
          <table className="min-w-full bg-white border border-gray-200">
            <thead className="bg-gray-100 border-b">
              <tr>
                <th className="text-left py-3 px-4 text-gray-700">cultivation Realm</th>
                <th className="text-left py-3 px-4 text-gray-700">1st Level Referrals</th>
                <th className="text-left py-3 px-4 text-gray-700">2nd Level Referrals</th>
                <th className="text-left py-3 px-4 text-gray-700">3rd Level Referrals</th>
                <th className="text-left py-3 px-4 text-gray-700">4th Level Referrals</th>
                <th className="text-left py-3 px-4 text-gray-700">5th Level Referrals</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((item, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4">{item.realm}</td>
                  <td className="py-3 px-4">{item.level1}</td>
                  <td className="py-3 px-4">{item.level2}</td>
                  <td className="py-3 px-4">{item.level3}</td>
                  <td className="py-3 px-4">{item.level4}</td>
                  <td className="py-3 px-4">{item.level5}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Table;
